import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function PoliceReport(props: any) {
  return (
    <DocumentUploadField
      title="Police Report in case of accidental death and death at home (Optional)"
      onUploaded={props.setPoliceReport}
    />
  );
}
